<template>
  <div>
    <l-tables :tableConfig="tableConfig" :key="componentKey"  ref='childTable' :searchParams='searchData'  :noCreatText="$t('admin.sensitive.noData')" :ImgSrc='nullImg' @tableChange="handleTableHeaderChange">
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('admin.sensitive.placeholder')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
        </a-input>
      </template>
      <template #words="{ record }">
        <a-tooltip placement="bottom">
          <template slot="title">
            <div>{{ record.words }}</div>
          </template>
          <div class='overF'>{{ record.words }}</div>
        </a-tooltip>
      </template>

      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('admin.sensitive.create') }}</a-button>
      </template>
      <template slot="importFile">
        <a-button class='import_cla' type="primary">
          <input type="file" style='opacity: 0' accept='.txt' multiple="multiple" @change="readFile" />
          {{ $t('admin.sensitive.batchImport') }}
        </a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('admin.sensitive.create') }}</a-button>
      </template>

    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import { getTrainingRoomList, postSensitiveWordsSave, teacherList } from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'

export default {
  components: {
    LTables
  },
  data() {
    return {
      componentKey:0,
      childTable:null,
      nullImg:require('@/assets/img/bj_zanwushujv.png'),
      keyword: undefined,
      searchData:{
        keyword:''
      },
      txtContent: null,
      tableConfig: {
        tableName: this.$t('admin.sensitive.title'),
        tableColumns: [
          {
            title: this.$t('admin.sensitive.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80,
          },
          {
            title: this.$t('admin.sensitive.columns.word'),
            dataIndex: 'title',
            key: 'title',
            align: 'center',
            ellipsis:true,
            width: 300,
            scopedSlots: { customRender: 'words' }
          },
          {
            title: this.$t('admin.sensitive.columns.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            width: 100,
            // sortDirections: ["descend", "ascend","descend"],
            // sorter: true,
          },
          {
            title: this.$t('admin.sensitive.columns.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            width: 100,
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.sensitive.deleteConfirm.title'),
          content: this.$t('admin.sensitive.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/sensitive/words/list',
          del: '/admin/sensitive/words/delete'
        },
        // tableData:[],
        tableEditRouteNName:'sensitiveAdd'

      }
    }
  },
  methods: {
    readFile(event) {
      const file = event.target.files;
      if (!file) {
        return;
      }
      for(let i=0;i<file.length;i++){
        const reader = new FileReader();
        reader.onload = (e) => {
        console.log(e.target.result)
          let param={
            words:  e.target.result
          }
          postSensitiveWordsSave(param).then(res => {
            if (res.code == 200) {

            }
          })
          if(i==file.length-1){
            console.log('ok')
            this.$message.success(this.$t('admin.sensitive.importSuccess'))
            this.componentKey+=1
            this.$refs.childTable.getList()
          }
        };
        reader.readAsText(file[i], 'UTF-8'); // 默认编码格式为UTF-8，可根据需要更改

      }


    },
    search(){
      this.searchData.keyword = this.keyword
    },
    // 新建
    create() {
      this.$router.push({
        name: 'sensitiveAdd'
      })
    },
    handleTableHeaderChange([filters,getList,sorter]) {
      const filterKey = [['statusName', 'status'], ['recommendName', 'isRecommend']]
      let timeSort={}
      // 升序
      if(sorter.order === 'ascend'){
        timeSort.time_sort = 2
        // 倒序
      }else if(sorter.order === 'descend'){
        timeSort.time_sort = 1
      }
      const result = {...timeSort}
      filterKey.forEach(item => {
        if (filters[item[0]]) {
          result[item[1]] = filters[item[0]].map(f => {
            if (f === '开启' || f === '未推荐') {
              return 1
            }
            return 2
          })
          result[item[1]] = result[item[1]].length > 1 ? '' : result[item[1]][0]
        }
      })
      getList({condition:result})
    },

  }
}
</script>

<style lang="less" scoped>
.overF{
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.import_cla{
  cursor: pointer;
  background: linear-gradient( 227deg, #72899D 0%, #9BB3C8 100%);
  margin-right: 12px;
  position: relative;;
  input{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
.import_cla:hover{
  background: linear-gradient( 227deg, #72899D 0%, #9BB3C8 100%) !important;
}
</style>
